(() => {
  const initialize = (root) => {
    if (!root || root.dataset.avfReady === 'true') return;
    root.dataset.avfReady = 'true';
    const cards = [...root.querySelectorAll('[data-avf-card]')];
    const buttons = [...root.querySelectorAll('[data-avf-filter]')];
    const empty = root.querySelector('[data-avf-empty]');
    const shop = root.querySelector('#avf-air-shop');

    const applyFilter = (filter) => {
      let visible = 0;
      cards.forEach((card) => {
        const show = filter === 'all' || card.dataset.avfCard === filter;
        card.hidden = !show;
        if (show) visible += 1;
      });
      buttons.forEach((button) => {
        const active = button.dataset.avfFilter === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      if (empty) empty.hidden = visible !== 0;
    };

    buttons.forEach((button) => button.addEventListener('click', () => applyFilter(button.dataset.avfFilter || 'all')));
    root.querySelectorAll('[data-avf-jump]').forEach((button) => {
      button.addEventListener('click', () => {
        applyFilter(button.dataset.avfJump || 'all');
        shop?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    });
  };

  const initializeAll = (scope = document) => scope.querySelectorAll('[data-avf-root]').forEach(initialize);
  document.addEventListener('DOMContentLoaded', () => initializeAll());
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
